import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { isIOS, isStandalone } from "../lib/push";

const KEY = "oce_install_nudge_v1";

// One-time prompt nudging visitors to install OCE DOGS for live alerts.
const InstallNudge = () => {
  const [show, setShow] = useState(false);
  const [deferred, setDeferred] = useState(null);
  const ios = isIOS();

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBIP);
    let t;
    if (ios) t = setTimeout(() => setShow(true), 4000); // iOS has no beforeinstallprompt
    return () => { window.removeEventListener("beforeinstallprompt", onBIP); if (t) clearTimeout(t); };
  }, [ios]);

  const dismiss = () => { try { localStorage.setItem(KEY, "1"); } catch (_) {} setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (_) {}
    dismiss();
  };

  if (!show) return null;
  return (
    <div data-testid="install-nudge" className="fixed z-[9998] bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm bg-[#13151B] border border-[#D4A94A]/50 tactical-frame p-4 shadow-[0_0_30px_rgba(0,0,0,0.5)] fade-in">
      <button data-testid="install-nudge-close" onClick={dismiss} className="absolute top-2 right-2 text-[#64748B] hover:text-[#F1F5F9]"><X className="w-4 h-4" /></button>
      <div className="flex items-start gap-3">
        <img src="/pwa-192.png" alt="OCE DOGS" className="w-10 h-10 shrink-0 tactical-frame-sm" />
        <div className="min-w-0 pr-4">
          <div className="font-stencil font-black uppercase text-sm text-[#F1F5F9]">Install OCE DOGS</div>
          <p className="font-mono text-[11px] text-[#94A3B8] mt-1 leading-relaxed">
            {ios
              ? "Add to your home screen for live server & forum alerts — tap the Share button, then \u201CAdd to Home Screen\u201D."
              : "Get it on your home screen and receive live server & forum alerts."}
          </p>
          {!ios && deferred && (
            <button data-testid="install-nudge-install" onClick={install} className="mt-3 inline-flex items-center gap-1.5 bg-[#D4A94A] hover:bg-[#E5BD60] text-black font-stencil font-black uppercase text-xs px-4 py-2 tactical-frame-sm transition-colors">
              <Download className="w-4 h-4" /> Install App
            </button>
          )}
          {ios && (
            <div className="mt-2 inline-flex items-center gap-1.5 font-mono text-[11px] text-[#D4A94A]"><Share className="w-3.5 h-3.5" /> Share → Add to Home Screen</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InstallNudge;
